import { getFieldConfig } from "./index";
import {
  IPackagingFieldsConfig,
  IFieldConfig,
  PACKAGING_FIELDS,
  resolveMapsToPackageDetails,
} from "./types";

interface IShipment {
  pieces?: string | number;
  weight?: string | number;
  loosePieces?: string | number;
  packagingItems?: any[];
}

const getPayloadValue = (
  fieldCfg: IFieldConfig,
  value: string | number | undefined
): number | null => {
  if (!fieldCfg.visible && !fieldCfg.required) return 0;
  if (!fieldCfg.visible) return null;
  return parseInt(String(value)) || 0;
};

export const buildPackagingPayload = (
  shipment: IShipment,
  packagingConfig: IPackagingFieldsConfig,
  getValidPackageItems: (items: any[]) => any[]
) => {
  const piecesCfg = getFieldConfig(packagingConfig, PACKAGING_FIELDS.PIECES);
  const weightCfg = getFieldConfig(packagingConfig, PACKAGING_FIELDS.WEIGHT);
  const loosePiecesCfg = getFieldConfig(packagingConfig, PACKAGING_FIELDS.LOOSE_PIECES);
  const includePackageRows = packagingConfig.fieldOrder.some((name) => {
    const cfg = packagingConfig.fieldMap[name];
    return (
      cfg?.visible && resolveMapsToPackageDetails(cfg)
    );
  });

  const rawPackageDetails = includePackageRows
    ? getValidPackageItems(shipment.packagingItems ?? [])
    : [];

  // loosePiecesCfg is undefined only when loosePieces is absent from config entirely
  const loosePiecesPerRow =
    loosePiecesCfg !== undefined &&
    resolveMapsToPackageDetails(loosePiecesCfg);

  const packageDetails = rawPackageDetails.map((row) => {
    // loosePieces not in config at all — don't touch the row
    if (!loosePiecesCfg) return row;
    // loosePieces IS in config; source depends on whether it's a per-row or shipment-level field:
    //   per-row (mapsToPackageDetails): prefer user-edited row value, fall back to inbound shipment value
    //   shipment-level / hidden: always use the shipment value (getPayloadValue handles visible:false → 0)
    const loosePiecesSource = loosePiecesPerRow
      ? (row.loosePieces ?? shipment.loosePieces ?? undefined)
      : (shipment.loosePieces ?? undefined);
    return { ...row, loosePieces: getPayloadValue(loosePiecesCfg, loosePiecesSource) };
  });

  return {
    pieces: getPayloadValue(piecesCfg, shipment.pieces),
    weight: getPayloadValue(weightCfg, shipment.weight),
    packageDetails,
  };
};
